import React from 'react'
import Wizard from '@modules/form-wizard'
import SERVICE_PROPS from '@helpers/extract-service-props'
import islands from '@constants/islands'
import { OPENMAPFIELDS } from '@modules/open-street-map-field'
import { BUSINESS_FIELDS, fullName } from '@modules/form-wizard/utils'
import Swal from 'sweetalert2'
import toastr from '@modules/toastr'
import moment from 'moment'



export default class EnvironmentClearanceSupplementaryForm extends React.Component {
  resource = '/moen/depp/env_clearance_supp_forms'
  form_key = 'env_clearance_supp_form'
  defaults = {}
  state = { record: null, loading: false, all_reviewers: [] }

  // Delete lines as needed
//   fee           = 99
  free          = true
//   postpaid      = true
  skip_location = true
  hide_buttons  = {
    status: true,
    deny: true,
  }
  coordinates = null

  metricRegex = /[m2]|\D/gm

  foremost = null

  // Allow map component selected coordinates to translate to form latitude and longitude fields
  validate = async values => {
    const update = {}
    const purposeArray = Array.from(values.purpose_ghost || []) // Convert Checklist of type Set to Array
    const purposeList = purposeArray.filter(x => x != 'other')

    // Validation: Ensure at least one complaint type is selected
    if (purposeArray.length === 0) {
      return `You need to select at least one purpose for your project. If you do not see a purpose that applies to your project, 
        please select "Other" and specify the purpose in the "Other Purpose" field.`
    }
  
    if (purposeArray.includes('other')) {
        const otherList = values.purpose_other.map(x => x.purpose)
        const mergedList = purposeList.concat(otherList);
        const objectList = mergedList.map(item => ({ purpose: item }));
        // console.log(purposeList);
        // console.log(otherList);
        // console.log(objectList);
        update.purpose_list = objectList
    } else {
        const objectList = purposeList.map(item => ({ purpose: item }));
        update.purpose_list = objectList
        // console.log(objectList);
    }
    
    if(this.coordinates) {
      update.latitude = this.coordinates[0]
      update.longitude = this.coordinates[1]
    }

    // Save combined value and metric for coast distance and total area fields
    update.coast_distance = `${values.coast_distance || ''} ${values.coast_distance_metric || ''}`.trim()
    update.total_area = `${values.total_area || ''} ${values.total_area_metric || ''}`.trim()
    // console.log('update', update)

    return update
  }

  custom_actions = [
    // Senior Officer Actions
    {
      text: 'Assign Officer',
      icon: 'bullhorn',
      roles: [['senior_officer', 'director', 'deputy_director']],
      test: r => ['pending', 'processing'].includes(r.application_decision),
      fn: async record => {
        // Get the list of officers
        const officerList = {};
        const { data } = await $app.axios.get(`${this.resource}/show_reviewers`)
        const officerMap = data.records.map(x => {
          return { id: x.id, name: `${x.first_name} ${x.last_name}`, islands_worked_list: (x?.profile?.islands_worked_list || x?.profiles?.islands_worked_list) }
        })
        this.setState({ all_reviewers: officerMap })
        this.state.all_reviewers.forEach(e => {
          officerList[`${e.id}`] = e.name.toUpperCase();
        })

        let officerID = null
        const {isDismissed, value} = await Swal.fire({
          icon: 'question',
          title: 'Assign Officer for review',
          html: `
            Select which officer you would wish to assign to this application.
          `,
          input: 'select',
          inputOptions: officerList,
          showCancelButton: true,
          confirmButtonText: 'Send',
        })
  
        if (isDismissed) return

        officerID = value
        // console.log(officerID)
        this.setState({ loading: true })
        const { props, resource, form_key } = this
        const { history, location } = props

        try {
          await $app.axios.put(resource + '/update_application', {
            [form_key]: {
              form_num: record.form_num,
              application_decision: 'assign reviewer',
              reviewer_id: officerID,
            },
          })

          if (location?.state?.view) {
            const view = { ...location.state.view }
            console.log(view)
            view.application_decision = 'assigned reviewer'

            history.replace(location.pathname, {
              ...location.state,
              view,
            })
          }

          toastr.success('Success', 'Application approved for review successfully')
        } catch (err) {
          console.error(err)
          Swal.fire(
            'Oops...',
            'An error occurred while approving the application for review',
            'error'
          )
        } finally {
          this.setState({ loading: false })
        }
      }
    },

    // All Officer Actions
    {
      text: 'Claim Application',
      icon: 'check',
      roles: [['officer', 'senior_officer', 'director', 'deputy_director']],
      test: r => {
        if (['pending', 'processing'].includes(r.application_decision) && r.reviewer_id == null) {
          return true
        }

        if (['pending', 'processing'].includes(r.application_decision) && $app.hasAnyRole(['senior_officer', 'director', 'deputy_director']) && r.reviewer_id != $app.current_user.id) {
          return true
        }

        return false
      },
      fn: async record => {
        const { isDismissed, value } = await Swal.fire({
          icon: 'question',
          title: 'Claim Application for Review',
          html: `
            Are you claiming this application for review, 
            <strong>${fullName(record.user, 'initial')}</strong>?
          `,
          input: 'select',
          inputOptions: {
            'claimed': "I claim this application for review",
            'no': "I do not wish to claim this application",            
          },
          showCancelButton: true,
        })

        if (isDismissed) return
        if (value === 'no') return

        this.setState({ loading: true })
        const { props, resource, form_key } = this
        const { history, location } = props

        try {
          await $app.axios.put(resource + '/update_application', {
            [form_key]: {
              form_num: record.form_num,
              application_decision: value,
            },
          })

          if (location?.state?.view) {
            const view = { ...location.state.view }
            console.log(view)
            view.application_decision = 'claimed'

            history.replace(location.pathname, {
              ...location.state,
              view,
            })
          }

          toastr.success('Success', 'Application review submitted successfully')
        } catch (err) {
          console.error(err)
          Swal.fire(
            'Oops...',
            'An error occurred while reviewing the application',
            'error'
          )
        } finally {
          this.setState({ loading: false })
        }
      }
    },
    {
      text: 'Defer - Request Part B',
      icon: 'step-forward',
      roles: [['officer', 'senior_officer', 'director', 'deputy_director']],
      test: r => {
        if (['pending', 'processing'].includes(r.application_decision) && r.reviewer_id == $app.current_user.id) {
          return true
        }

        if ($app.hasAnyRole(['director', 'deputy_director']) && !['approved', 'deferred', 'denied'].includes(r.application_decision)) {
          return true
        }

        return false
      },
      fn: record =>
        Swal.fire({
          title: 'Are you sure that you would like to defer this application and request them to fill out Part B of the form?',
          text: 'By clicking "Confirm", you are acknowledging that you have reviewed this application and are requesting the applicant to fill out Part B before final approval. Would you like to proceed?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Confirm',
        }).then(async result => {
          if (result.isConfirmed) {
            await this.deferPartB(record)
          }
        }),
    },
    {
      text: 'Approve Application',
      icon: 'check-square',
      roles: [['officer', 'senior_officer', 'director', 'deputy_director']],
      test: r => {
        if (['pending', 'processing'].includes(r.application_decision) && r.reviewer_id == $app.current_user.id) {
          return true
        }

        if ($app.hasAnyRole(['director', 'deputy_director']) && !['approved', 'deferred', 'denied'].includes(r.application_decision)) {
          return true
        }

        return false
      },
      fn: async record => {
        let { isDismissed, value } = await Swal.fire({
          icon: 'question',
          title: 'Are you sure that you would like to approve this application?',
          html: `
            By selecting "Confirm", you are acknowleding that you have reviewed this application and are satisfied with its contents. Would you like to approve?
          `,
          input: 'select',
          inputOptions: {
            'yes': "Yes approve",
            'no': "Cancel",
            'other': "Yes, approve with custom messaging (please specify)",     
          },
          showCancelButton: true,
        })

        if (isDismissed) return
        if (value === 'no') return
        if (value === 'other') {
          const { isDismissed: isDismissedOther, value: valueOther } = await Swal.fire({
            icon: 'info',
            title: 'Approve Application with Custom Message',
            html: `
              ${record.custom_message ? `
                <div class="text-left mb-2">
                  <strong>Current message:</strong><br/>${record.custom_message}
                </div>
              ` : ''}
              Please specify the custom message you would like to include when approving this application for further review of this application,
              <strong>${fullName(record.user, 'initial')}</strong>?
            `,
            input: 'textarea',
            inputAttributes: { rows: 6 },
            showCancelButton: true,
          })

          if (isDismissedOther) return
          if (!valueOther) return
          value = valueOther
        }

        if (value === 'yes') value = null

        const expiry = moment(record.license_expiry_date)
        const hasExpiry = !!record.license_expiry_date && expiry.isValid()

        const { isDismissed: isDismissedExpiry, value: months } = await Swal.fire({
          icon: 'info',
          title: 'Set Licence Expiry Date',
          html: `
            ${hasExpiry ? `
              <div class="text-left mb-2">
                <strong>Current expiry date:</strong> ${expiry.format('MMMM Do YYYY')}
              </div>
            ` : ''}
            Please enter the number of months the licence being issued with this approval
            will remain valid for. The expiry date is calculated from today's date.
          `,
          input: 'number',
          inputPlaceholder: 'Number of months',
          inputAttributes: { min: 1, step: 1 },
          showCancelButton: true,
          confirmButtonText: 'Approve',
          inputValidator: val => {
            const num = Number(val)

            if (!val || !Number.isInteger(num) || num < 1) {
              return 'Please enter a valid number of months'
            }
          },
        })

        if (isDismissedExpiry) return
        if (!months) return

        const license_expiry_date = moment()
          .add(Number(months), 'months')
          .format('YYYY-MM-DD')

        this.approve(record, value, license_expiry_date)
      }
    },
    {
      text: 'Deny',
      icon: 'ban',
      roles: [['officer', 'senior_officer', 'director', 'deputy_director']],
      test: r => {
        if (['pending', 'processing'].includes(r.application_decision) && r.reviewer_id == $app.current_user.id) {
          return true
        }

        if ($app.hasAnyRole(['director', 'deputy_director']) && !['approved', 'deferred', 'denied'].includes(r.application_decision)) {
          return true
        }

        return false
      },
      fn: record =>
        Swal.fire({
          icon: 'error',
          title: 'Confirm Denial',
          text: 'Are you sure you want to deny this application?',
          confirmButtonText: 'Deny',
          showCancelButton: true,
        }).then(async result => {
          if (result.isConfirmed) {
            await this.deny(record)
          }
        }),
    },
  ]

  purposeDescriptions = {
    'existing structure': 'To repair, perform maintenance, or conduct a minor alteration of an existing public or private structure',
    'minor ops/maint': `Operation, repair, maintenance, or minor alteration of existing public 
        or private structures, facilities, mechanical equipment, or 
        topographical features,  that does not result in any change to the 
        existing structures, facilities, equipment, or features`,
    'small res build': 'The construction of a residential dwelling (single family), not exceeding a six multi-family dwelling',
    'abandon/decomm': 'Abandonment/Decommissioning',
    'new commercial': 'New large scale commercial development',
    'new subdiv/dev': 'New Housing Subdivision or Development',
  }

// Defer Customer requiring them to fill out Part B of the form before final approval
  deferPartB = async (record) => {
    this.setState({ loading: true })

    const { resource, form_key, props } = this
    const { history, location } = props
    const { axios } = $app

    try {
      await axios.put(resource + '/update_application', {
        [form_key]: {
          form_num: record.form_num,
          application_decision: 'deferred',
        },
      })

      if (location?.state?.view) {
        const view = { ...location.state.view }
        view.application_decision = 'deferred'

        history.replace(location.pathname, {
          ...location.state,
          view,
        })
      }

      Swal.fire(
        'Submitted!',
        'The application is now eligible for part B form to be submitted.',
        'success'
      )
    } catch (error) {
      console.error(error)
      Swal.fire(
        'Oops..',
        error.response?.data?.error ||'Something went wrong with trying to defer this application for form part B',
        'error'
      )
    } finally {
      this.setState({ loading: false })
    }
  }

  approve = async (record, custom_message = '', license_expiry_date = null) => {
    this.setState({ loading: true })

    const { props, resource, form_key } = this
    const { history, location } = props
    const { axios } = $app

    try {
      await axios.put(resource + '/update_application', {
        [form_key]: {
          form_num: record.form_num,
          application_decision: 'approved',
          custom_message,
          license_expiry_date,
        },
      })

      if (location.state?.view) {
        const view = { ...location.state.view }
        view.application_decision = 'approved'

        history.replace(location.pathname, { ...location.state, view })
      }

      toastr.success('Success', 'Application successfully approved')
    } catch (error) {
      console.error(error)
      toastr.error('Error', error.response?.data?.error || 'Unable to approve application')
    } finally {
      this.setState({ loading: false })
    }
  }

  deny = async record => {
    this.setState({ loading: true })

    const { props, resource, form_key } = this
    const { history, location } = props
    const { axios } = $app

    try {
      await axios.put(resource + '/update_application', {
        [form_key]: {
          form_num: record.form_num,
          application_decision: 'denied',
        },
      })

      if (location.state?.view) {
        const view = { ...location.state.view }
        view.application_decision = 'denied'

        history.replace(location.pathname, { ...location.state, view })
      }

      toastr.success('Success', 'Application denied')
    } catch (error) {
      console.error(error)
      toastr.error('Error', error.response?.data?.error || 'Unable to deny application')
    } finally {
      this.setState({ loading: false })
    }
  }

  columns = props => {

    const purposeFinder = value => {
      return Object.keys(this.purposeDescriptions).find(key => this.purposeDescriptions[key] === value) || value
    }

    return [
      {
        name: 'Project Island',
        width: '160px',
        selector: row => row.project_island || 'N/A',
        sortable: true,
        searchable: r => r.project_island,
      },
      {
        name: 'Purpose',
        selector: row => row.purpose_list ? row.purpose_list.map(item => purposeFinder(item)).join(', ') : 'N/A',
        sortable: true,
        searchable: r => r.purpose_list,
      },
      {
        name: 'Officer Assigned',
        width: '200px',
        selector: row => row.reviewer ? `
          ${row.reviewer.first_name[0].toUpperCase() + row.reviewer.first_name.substring(1)} ${row.reviewer.last_name[0].toUpperCase() + row.reviewer.last_name.substring(1)}
        ` : 'N/A',
        sortable: true,
        // searchable: r => r.reviewer,
      },
    ]
  }

  fields = (form, formRef) => [
    {
        heading: '<h2>PART A</h2>'
    },

    "::Applicant Information",
    ...BUSINESS_FIELDS(form),
    {
      name: 'i_am_applicant',
      label: 'Are you applying on behalf of someone else?',
      options: [
        { label: 'Yes', value: false },
        { label: 'No, I am applying for myself', value: true },
      ],
    },
    {
      name: 'app_first_name',
      label: 'First Name',
      hide: form.i_am_applicant,
    },
    {
      name: 'app_middle_name',
      label: 'Middle Name',
      hide: form.i_am_applicant,
      required: false,
    },
    {
      name: 'app_last_name',
      label: 'Last Name',
      hide: form.i_am_applicant,
    },
    {
      name: 'project_name',
      label: 'Project Name',
      required: false,
      hint: 'Enter the name of the project for future reference',
    },
    {
        name: 'postal_address'
    },
    // {
    //     name: 'street_name',
    //     label: 'Street name and Lot number',
    //     type: 'textarea'
    // },
    {
        name: 'phone_number',
        label: 'Phone #',
        type: 'phone',
        required: false,
    },
    {
        name: 'phone_number_alt',
        label: 'Alternate Phone #',
        type: 'phone',
        required: false,
    },
    {
        heading: '<h4 style="font-weight:bold;">Project Classification</h4>'
    },
    // {
    //     name: 'location_island',
    //     label: 'Island of proposed property',
    //     options: islands
    // },
    {
        heading: `<p>1. Please state the Activity as well as the purpose of the project for which the Certificate of Environmental Clearance application is being submitted.</p>`,
    },
    {
        name: 'all_activities_list',
        label: 'List all the activities that apply:',
        columns: ['activity'],
        format: v => v.activity
    },
    {
        name: 'purpose_list',
        label: '2. Purpose',
        hint: 'Select all that apply',
        columns: ['purpose'],
        format: v => v.purpose,
        multi: true,
        save: true,
        hide: true,
    },
    {
        name: 'purpose_ghost',
        label: '2. Purpose',
        hint: 'Select all that apply',
        type: 'checklist',
        multi: true,
        options: [
            { label: this.purposeDescriptions['existing structure'], value: this.purposeDescriptions['existing structure'] },
            { label: this.purposeDescriptions['minor ops/maint'], value: this.purposeDescriptions['minor ops/maint'] },
            { label: this.purposeDescriptions['small res build'], value: this.purposeDescriptions['small res build'] },
            { label: this.purposeDescriptions['abandon/decomm'], value: this.purposeDescriptions['abandon/decomm'] },
            { label: this.purposeDescriptions['new commercial'], value: this.purposeDescriptions['new commercial'] },
            { label: this.purposeDescriptions['new subdiv/dev'], value: this.purposeDescriptions['new subdiv/dev'] },
            { label: 'Other', value: 'other' }
        ],
        view: false,
    },
    {
        name: 'purpose_other',
        label: 'Other Purpose',
        columns: ['purpose'],
        hide: (() => {
          const purposeArray = Array.from(form.purpose_ghost || []) // Convert Checklist of type Set to Array
          return !purposeArray.includes('other')
        })(),
        view: false
    },

    `::3. Is the project located in an environmentally sensitive area as defined by Environmental Planning and Protection 
    (Amendment) Act, 2024, i.e. “environmentally sensitive area means an area (a) in which plant or animal life or 
    their habitats are either rare or especially valuable because of their special nature or role in any ecosystem and 
    which may be easily disturbed or degraded by human activities and developments; and (b) designed under section 
    23;`,
    {
        name: 'environmentally_sensitive_area',
        label: `Is the project located in an environmentally sensitive area as defined by Environmental Planning and Protection 
            (Amendment) Act, 2024`,
        type: 'select:bool',
    },
    {
        name: 'project_category',
        label: 'Select a category that Certificate of Environmental Clearance (CEC) applies to',
        options: ['New', 'Modification', 'Abandonment', 'Decommissioning']
    },


    "::SPACER",
    {
        heading: '<h4 style="font-weight:bold;">A. General Information</h4>'
    },

    "::4. Location of proposed activity",
    ...OPENMAPFIELDS(this, form, formRef, 'project_street_address', false),
    // FIELDS TO ADD TO DB MODEL = latitude and longitude
    {
        name: 'project_island',
        label: 'Island/Constituency',
        options: islands,
    },
    {
        name: 'project_street_address',
        label: 'Street Address',
    },
    {
        name: 'project_lot_no',
        label: 'Lot No.',
    },

    "::5. Please complete the following:",
    {
        name: 'own_property',
        label: 'Do you own the property on which the activity is intended to be carried out?',
        type: 'select:bool',
    },
    /*{
        name: 'if_yes',
        label: 'Please attach certified copies of Proof of ownership.',
        hide: !form.own_property
    }, */
    {
        name: 'adjourning_owners_list',
        label: '6. Names and addresses of adjourning property owners',
        fields: ['first_name', 'last_name', 'address'],
        required: false,
        // format: v => [v.first_name, v.last_name, v.address]
    },

    "::SPACER",
    "::7. Site description (physical setting of the proposal, both developed and undeveloped area)",
    {
        name: 'total_area_metric',
        label: 'Total area intended for the activity (ha or m2)',
        hint: '1 hectare/ha = 10000 square meters/m2',
        save: false,
        view: false,
        options: [
            { label: 'hectare/ha', value: 'ha' },
            { label: 'square meter/m2', value: 'm2' }
        ],
    },
    {
        name: 'total_area',
        label: `Total area intended for the activity (${form.total_area_metric})`,
        type: 'number',
        hint: `In ${form.total_area_metric}`,
        icon: `text-${form.total_area_metric}`,
        hide: !form.total_area_metric,
        view: {
          label: 'Total area intended for the activity',
        },
    },
    {
        name: 'coast_distance_metric',
        label: 'How far is the projected lot from the coast (m/ft)',
        hint: '1 meter/m = 3.28 foot/ft',
        save: false,
        view: false,
        options: [
            { label: 'meters/m', value: 'm' },
            { label: 'feet/ft', value: 'ft' }
        ],
    },
    {
        name: 'coast_distance',
        label: `How far is the projected lot from the coast (${form.coast_distance_metric})`,
        type: 'number',
        hint: `In ${form.coast_distance_metric}`,
        icon: `text-${form.coast_distance_metric}`,
        hide: !form.coast_distance_metric,
        view: {
          label: 'How far is the projected lot from the coast',
        },
    },
    {
        name: 'previous_site_use',
        label: 'Previous site land use',
        options: [
            'Residential',
            'Agricultural',
            'Commercial',
            'Industrial',
            'Forestry',
        ],
    },
    {
        name: 'present_site_use',
        label: 'Present site land use',
        options: [
            'Residential',
            'Agricultural',
            'Commercial',
            'Industrial',
            'Forestry',
            { value: 'Unaltered', label: 'Unaltered (Last 20 years)' }
        ],
    },
    {
        name: 'project_percentage',
        label: '8. What percentage of the intended project area would be cleared of vegetation?',
        type: 'number',
        icon: 'text-%',
        min: 0,
        max: 100,
        onBlur: v => {
          if (v < 0) return { project_percentage: 0 }
          if (v > 100) return { project_percentage: 100 }
        },
        view: v => `${v}%`,
    },

    "::SPACER",
    {
        name: 'prev_app',
        label: '9. Previous Application for Certificate of Environmental Clearance for this site?',
        type: 'select:bool',
    },
    {
        name: 'prev_app_ref_no',
        label: 'Reference No. of most recent application',
        hide: !form.prev_app
    },
    {
        name: 'commencement_date',
        label: '10. Intended commencement date',
        type: 'date',
        showYearDropdown: true,
    },

    "::Uploads",
    {
      name:'lease_agreement_upload',
      key: 'image.1',
      label:'Lease Agreement',
      hide: form.own_property,
      type: 'file:all',
    },
    {
      name:'proof_of_land_ownership_upload',
      key: 'image.2',
      label:'Proof of Land Ownership',
      hide: !form.own_property,
      type: 'file:all',
    },
    {
      name:'identification_upload',
      key: 'image.3',
      label:'Document of Identification',
      type: 'file:all',
    },
    {
      name:'previous_c_e_c_upload',
      key: 'image.4',
      label:'Previous Certificate of Environmental Clearance (CEC)',
      hide: !form.prev_app,
      type: 'file:all',
    },
  ]

  render = () => <Wizard {...SERVICE_PROPS(this)} />

}